export default __webpack_public_path__ + "static/media/emailIcon.ec90420f.svg";